/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "Reality.Reality.Api";

export interface HistoryAlbumMyRecord {
  totalBroadcastViewHour: number;
  totalBroadcastHour: number;
}

function createBaseHistoryAlbumMyRecord(): HistoryAlbumMyRecord {
  return { totalBroadcastViewHour: 0, totalBroadcastHour: 0 };
}

export const HistoryAlbumMyRecord = {
  encode(message: HistoryAlbumMyRecord, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.totalBroadcastViewHour !== 0) {
      writer.uint32(8).int64(message.totalBroadcastViewHour);
    }
    if (message.totalBroadcastHour !== 0) {
      writer.uint32(16).int64(message.totalBroadcastHour);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HistoryAlbumMyRecord {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryAlbumMyRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.totalBroadcastViewHour = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.totalBroadcastHour = longToNumber(reader.int64() as Long);
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryAlbumMyRecord {
    return {
      totalBroadcastViewHour: isSet(object.totalBroadcastViewHour)
        ? globalThis.Number(object.totalBroadcastViewHour)
        : 0,
      totalBroadcastHour: isSet(object.totalBroadcastHour) ? globalThis.Number(object.totalBroadcastHour) : 0,
    };
  },

  toJSON(message: HistoryAlbumMyRecord): unknown {
    const obj: any = {};
    if (message.totalBroadcastViewHour !== 0) {
      obj.totalBroadcastViewHour = Math.round(message.totalBroadcastViewHour);
    }
    if (message.totalBroadcastHour !== 0) {
      obj.totalBroadcastHour = Math.round(message.totalBroadcastHour);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HistoryAlbumMyRecord>, I>>(base?: I): HistoryAlbumMyRecord {
    return HistoryAlbumMyRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HistoryAlbumMyRecord>, I>>(object: I): HistoryAlbumMyRecord {
    const message = createBaseHistoryAlbumMyRecord();
    message.totalBroadcastViewHour = object.totalBroadcastViewHour ?? 0;
    message.totalBroadcastHour = object.totalBroadcastHour ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
